export default "__VITE_ASSET__Cbmw$3xw__"